<template>
  <div>
    <!-- Suspend Modal -->
    <div class="modal fade suspend-modal" tabindex="-1" role="dialog" aria-hidden="true">
      <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content">
          <div class="modal-header bg-danger text-white">
            <h5 class="modal-title text-white fw-bold">
              <i class="mdi mdi-lock me-2"></i>Suspend Plot
            </h5>
            <button type="button" class="btn-close btn-close-white" data-bs-dismiss="modal"></button>
          </div>
          <div class="modal-body">
            <div class="alert alert-warning">
              <i class="mdi mdi-alert me-2"></i>
              You are about to suspend plot <strong>{{ plot.plotNumber }}</strong> owned by <strong>{{ plot.ownerNames }}</strong>.
            </div>

            <div class="form-group mb-3">
              <label class="form-label fw-semibold">Reason for Suspension <span class="text-danger">*</span></label>
              <textarea v-model="suspendReason" class="form-control" rows="3" placeholder="Enter reason for suspension"></textarea>
            </div>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Cancel</button>
            <button @click="submitSuspend" type="button" class="btn btn-danger" :disabled="!suspendReason">
              <i class="mdi mdi-lock me-2"></i>Suspend Plot
            </button>
          </div>
        </div>
      </div>
    </div>

    <!-- Reinstate Modal -->
    <div class="modal fade reinstate-modal" tabindex="-1" role="dialog" aria-hidden="true">
      <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content">
          <div class="modal-header bg-success text-white">
            <h5 class="modal-title text-white fw-bold">
              <i class="mdi mdi-lock-open me-2"></i>Reinstate Plot
            </h5>
            <button type="button" class="btn-close btn-close-white" data-bs-dismiss="modal"></button>
          </div>
          <div class="modal-body">
            <div class="alert alert-info">
              <i class="mdi mdi-information me-2"></i>
              You are about to reinstate plot <strong>{{ plot.plotNumber }}</strong>.
            </div>
            <p>This will change the plot status from <strong class="text-danger">Suspended</strong> to <strong class="text-success">Active</strong>.</p>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Cancel</button>
            <button @click="submitReinstate" type="button" class="btn btn-success">
              <i class="mdi mdi-check me-2"></i>Reinstate Plot
            </button>
          </div>
        </div>
      </div>
    </div>

    <!-- Vacate Modal -->
    <div class="modal fade vacate-modal" tabindex="-1" role="dialog" aria-hidden="true">
      <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content">
          <div class="modal-header bg-warning text-dark">
            <h5 class="modal-title fw-bold">
              <i class="mdi mdi-home-remove me-2"></i>Mark Plot as Vacant
            </h5>
            <button type="button" class="btn-close" data-bs-dismiss="modal"></button>
          </div>
          <div class="modal-body">
            <div class="alert alert-warning">
              <i class="mdi mdi-alert me-2"></i>
              You are about to mark plot <strong>{{ plot.plotNumber }}</strong> as vacant.
            </div>

            <div class="form-group mb-3">
              <label class="form-label fw-semibold">Reason for Vacating <span class="text-danger">*</span></label>
              <select v-model="vacateReason" class="form-select">
                <option value="">Select Reason</option>
                <option v-for="reason in vacateReasons" :key="reason.id" :value="reason.reasons">
                  {{ reason.reasons }}
                </option>
              </select>
            </div>

            <div class="form-group mb-3" v-if="vacateReason === 'Other'">
              <label class="form-label fw-semibold">Specify Reason</label>
              <textarea v-model="otherReason" class="form-control" rows="2" placeholder="Enter reason"></textarea>
            </div>

            <div class="alert alert-info">
              <small>
                <i class="mdi mdi-information me-2"></i>
                <strong>Note:</strong> This will clear the owner information and mark the plot as available for re-allocation.
                Outstanding balances will be retained.
              </small>
            </div>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Cancel</button>
            <button @click="submitVacate" type="button" class="btn btn-warning" :disabled="!vacateReason">
              <i class="mdi mdi-check me-2"></i>Mark as Vacant
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'PlotStatusModals',
  props: {
    plot: { type: Object, default: () => ({}) },
    vacateReasons: { type: Array, default: () => [] }
  },
  emits: ['suspend-plot', 'reinstate-plot', 'vacate-plot'],
  data() {
    return {
      suspendReason: '',
      vacateReason: '',
      otherReason: ''
    }
  },
  watch: {
    plot() {
      this.resetForms();
    }
  },
  methods: {
    submitSuspend() {
      if (!this.suspendReason) {
        alert("Please enter a reason for suspension");
        return;
      }
      this.$emit('suspend-plot', {
        plot: this.plot,
        reason: this.suspendReason
      });
    },

    submitReinstate() {
      this.$emit('reinstate-plot', {
        plot: this.plot
      });
    },

    submitVacate() {
      if (!this.vacateReason) {
        alert("Please select a reason for vacating");
        return;
      }
      this.$emit('vacate-plot', {
        plot: this.plot,
        reason: this.vacateReason === 'Other' ? this.otherReason : this.vacateReason
      });
    },

    resetForms() {
      this.suspendReason = '';
      this.vacateReason = '';
      this.otherReason = '';
    }
  }
}
</script>